import React from 'react';
import { useStepWriteMutation } from 'common-app/api/query/step-write';
import { routes } from 'core/router';
import { Redirect, useLocation, useParams } from 'react-router-dom';
import { useDossierContext } from './dossier.context';
import { DossierStep } from './dossier.vm';
export const useDossierOrchestration = () => {
    const { setDossier } = useDossierContext();
    const orchestrate = React.useCallback((step) => {
        setDossier(d => (d ? Object.assign(Object.assign({}, d), { step }) : null));
    }, [setDossier]);
    return orchestrate;
};
export const useDossierUpdateOrchestration = (step) => {
    const { dossier, setDossier } = useDossierContext();
    const mutation = useStepWriteMutation(step
        ? {
            variables: {
                dossierId: dossier === null || dossier === void 0 ? void 0 : dossier.id,
                step,
            },
        }
        : undefined);
    const [, { data, error }] = mutation;
    React.useEffect(() => {
        if (data && data.write_step && !error) {
            setDossier(d => (d ? Object.assign(Object.assign({}, d), { step: data.write_step }) : null));
        }
    }, [data, error]);
    return mutation;
};
export const DossierOrchestrationManager = props => {
    const { children, activated = true } = props;
    const { dossier } = useDossierContext();
    const location = useLocation();
    const { dossierId } = useParams();
    if (!dossier)
        return React.createElement(React.Fragment, null);
    if (!activated)
        return React.createElement(React.Fragment, null, children);
    const { step } = dossier;
    let redirect = dossierId ? routes.dossierWithId.unknown(dossierId) : routes.dossier.unknown;
    switch (step) {
        case null:
        case DossierStep.CONSENTS:
            redirect = dossierId ? routes.dossierWithId.consents(dossierId) : routes.dossier.consents;
            break;
        case DossierStep.SIGNATORIES:
            redirect = dossierId ? routes.dossierWithId.signatories(dossierId) : routes.dossier.signatories;
            break;
        case DossierStep.OCCUPANTS:
            redirect = dossierId ? routes.dossierWithId.occupants(dossierId) : routes.dossier.occupants;
            break;
        case DossierStep.EXPLICATIONS:
            redirect = dossierId ? routes.dossierWithId.explications(dossierId) : routes.dossier.explications;
            break;
        case DossierStep.SUMMARY:
            redirect = dossierId ? routes.dossierWithId.summary(dossierId) : routes.dossier.summary;
            break;
        case DossierStep.DOCUMENTS:
            redirect = dossierId ? routes.dossierWithId.documents(dossierId) : routes.dossier.documents;
            break;
        case DossierStep.VALIDATED:
            redirect = dossierId ? routes.dossierWithId.validated(dossierId) : routes.dossier.validated;
            break;
        case DossierStep.ERROR:
            redirect = dossierId ? routes.dossierWithId.error(dossierId) : routes.dossier.error;
            break;
        default:
            redirect = dossierId ? routes.dossierWithId.unknown(dossierId) : routes.dossier.unknown;
            break;
    }
    if (location.pathname === redirect || (location.pathname !== redirect && location.pathname.includes(redirect))) {
        return React.createElement(React.Fragment, null, children);
    }
    return React.createElement(Redirect, { to: redirect });
};
